















































import { FilterObject, Filters } from '@shared/interfaces/config';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import TextEditor from '@shared/components/forms/inputs/text-editor/text-editor.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import { ValidationObserver } from 'vee-validate';
import {
  DownloadPdfUsingTemplateFormModel,
  DownloadPdfUsingTemplateModel,
} from '@tools/interfaces/template';

@Component({
  name: 'bpc-download-pdf-using-template-modal',
  components: {
    'bpc-drawer-modal': DrawerModal,
    'bpc-select': Select,
    'bpc-entity-select': EntitySelect,
    'bpc-text-editor': TextEditor,
    'bpc-input': Input,
    'bpc-switch': Switch,
    ValidationObserver,
  },
})
export default class DownloadPdfUsingTemplateDrawer extends Vue {
  // PROPS
  @Prop({ type: String, required: true }) readonly entityName: string;
  @Prop({ type: String, required: false }) readonly title: string;
  @Prop({ type: String, required: false }) readonly selectLabel: string;
  @Prop({ type: String, default: 'download-pdf-using-template-modal' }) readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly withErrors: boolean;
  @Prop({ type: String, default: 'admin' }) readonly availabilityContext: string;
  @Prop({ type: String, default: 'pdf' }) readonly templateType: string;
  @Prop({ type: Array, default: () => [] }) readonly templateSelectorCustomFilters: FilterObject[];

  // @Prop({
  //   type: Array,
  //   default() {
  //     return [];
  //   },
  // })
  // readonly contactIds: number[];
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly errors: Record<string, string[]>;
  @Prop({
    type: Array,
    default() {
      return {};
    },
  })
  readonly selectedItemIds: number[];

  // DATA
  formModel: DownloadPdfUsingTemplateFormModel = {
    template: null,
  };
  showModalIndex = null;

  errorByField = {
    entity_name: null,
  };

  // COMPUTED
  get modalTitle() {
    return this.title
      ? this.$t(this.title)
      : this.$t('global.modals.download_pdf_using_template.title', {
          entityName: this.$t('global.models.' + this.entityName + '.name'),
          entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
          thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
          thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
        });
  }

  get modalBody() {
    return this.$t('global.modals.download_pdf_using_template.body', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  get templateSelectorFixedFilters() {
    return [
      {
        filterField: 'entity',
        value: this.entityName,
      },
      {
        filterField: 'available_in',
        value: this.availabilityContext,
      },
      {
        filterField: 'type',
        value: this.templateType,
      },
    ];
  }

  get templateSelectorFilters(): Filters {
    return [...this.templateSelectorFixedFilters, ...this.templateSelectorCustomFilters];
  }

  get selectedTemplateId(): number {
    return this.formModel?.template?.id || null;
  }

  // LIFECYCLE
  mounted() {
    this.showModalIndex = Date.now();
    if (this.showModal) {
      this.openModal();
    }
  }

  // METHODS
  closeModal() {
    this.showModalIndex = Date.now();
    this.cleanErrorByField();
    this.$emit('close-modal');
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  onDownloadPdf() {
    this.$emit('download-pdf-clicked', this.mapModel(this.formModel));
  }

  mapModel(model: DownloadPdfUsingTemplateFormModel): DownloadPdfUsingTemplateModel {
    return {
      template_id: this.selectedTemplateId,
      entity_name: model.template?.entity_value || model.template?.entity_value,
      entity_ids: this.selectedItemIds,
    };
  }

  cleanModel() {
    this.formModel = {
      template: null,
    };
  }

  modelFieldChange(field) {
    // this.$emit('model-change', field, this.formModel);
    this.errorByField[field] = null;
  }

  setErrorByField() {
    this.errorByField = Object.keys(this.errors).reduce((res, key) => {
      res[key] = this.errors[key][0] || null;
      return res;
    }, this.errorByField);
  }

  cleanErrorByField() {
    this.errorByField = {
      entity_name: null,
    };
  }

  // WATCHERS
  @Watch('errors', { deep: true })
  onErrorsChange() {
    this.cleanErrorByField();
    this.setErrorByField();
  }
  @Watch('showModal')
  onShowModalChange(val) {
    this.cleanModel();
    if (val) {
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
}
